import type RightsManagementFailureCode from "../store/schema/RightsManagementFailureCode";
import type IRMRestrictions from "../store/schema/IRMRestrictions";
import type Item from "owa-service/lib/contract/Item";
import type MeetingRequestMessageType from "owa-service/lib/contract/MeetingRequestMessageType";
import type ClientItem from "../store/schema/ClientItem";
import { DecryptionState } from "../store/schema/DecryptionState";
import { isAccountFeatureEnabled } from "owa-feature-flags";

export default function getItemRightsManagementRestrictions(item: Item | undefined): IRMRestrictions {
    const IRMData = item ? item.RightsManagementLicenseData : null;
    let restrictions = {
        ReplyAllowed: true,
        ReplyAllAllowed: true,
        ForwardAllowed: true,
        PrintAllowed: true,
        CopyAllowed: true,
        EditAllowed: true,
        ExportAllowed: true,
    } as IRMRestrictions;
    
    if (IRMData &&
        (!IRMData.RightsManagedMessageDecryptionStatus ||
            IRMData.RightsManagedMessageDecryptionStatus == 0)) {
        const { ReplyAllowed, ReplyAllAllowed, ForwardAllowed, PrintAllowed, ExtractAllowed, EditAllowed, ExportAllowed, } = IRMData;
        restrictions = {
            ReplyAllowed: !!ReplyAllowed,
            ReplyAllAllowed: !!ReplyAllAllowed,
            ForwardAllowed: !!ForwardAllowed,
            PrintAllowed: !!PrintAllowed,
            CopyAllowed: !!ExtractAllowed,
            EditAllowed: !!EditAllowed, // Edit right is common name for SaveAs
            ExportAllowed: !!ExportAllowed,
        };
    }
    
    // Apply addin defined access controls for addin-decrypted items.
    // IRM and addin decryption are mutually exclusive — items with
    // RightsManagementLicenseData never reach addin decryption, so
    // this only applies when no IRM data is present.
    // We intentionally blocks addin decryption when S/MIME or native encryption is applied.
    const clientItem = item as ClientItem;
    if (!IRMData && isAccountFeatureEnabled("addin-decryptionV1", clientItem?.MailboxInfo)) {
        const accessControls = clientItem?.AddinData?.AccessControls;
        if (clientItem?.AddinData?.DecryptionState === DecryptionState.InProgress) {
            // While decryption is in progress, set accesscontrols to false.
            restrictions.PrintAllowed = false;
            restrictions.CopyAllowed = true; // Setting this false will lead to disable screen capture by default
            restrictions.EditAllowed = false;
            restrictions.ExportAllowed = false;
        }
        else if (accessControls &&
            clientItem?.AddinData?.DecryptionState === DecryptionState.Completed) {
            // If decryption is completed and access controls are present, enforce the access controls defined by the add-in.
            restrictions.PrintAllowed = accessControls.AllowPrint;
            restrictions.CopyAllowed = accessControls.AllowCopyPaste;
            restrictions.EditAllowed = accessControls.AllowSave;
            restrictions.ExportAllowed = accessControls.AllowSave;
        }
    }
    
    // Also consider the 'Do Not Forward' flag if this is a meeting request message
    const meetingRequestMessage = item as MeetingRequestMessageType;
    const doNotForwardMeeting = meetingRequestMessage?.DoNotForwardMeeting;
    restrictions.ForwardAllowed = restrictions.ForwardAllowed && !doNotForwardMeeting;
    
    return restrictions;
}
